import { atom } from 'jotai';
import { IRevertData, IBulkCorrectionSummary } from '../components/spreadsheet/SpreadsheetTypes';
import { ValidationDismissalReason } from '../types/validation-types';

export const showUpdateAllExtractionsModalAtom = atom(false);
export const showAllValidationErrorsAtom = atom(false);
export const forceValidationAtom = atom(false);
export const validationLoadingAtom = atom(false);
// Extractions whose validation query has been refetching for longer than the
// debounce window; review surfaces render "validating" for them instead of the
// last result.
export const validatingExtractionIdsAtom = atom<string[]>([]);
// Extractions whose validation poll budget ran out (ValidationNotReadyError);
// review surfaces offer a retry for them.
export const validationNotReadyExtractionIdsAtom = atom<string[]>([]);
export const reviewEnablePhrasifierAtom = atom(true);
export const bulkCorrectionRevertDataAtom = atom<IRevertData[] | []>([]);
export const bulkCorrectionSummaryAtom = atom<IBulkCorrectionSummary[]>([]);
export const filteredExtractionIdsAtom = atom<string[]>([]);

export interface ValidationDismissalDialogState {
  isOpen: boolean;
  dataPoolId: string | null;
  validationId: number | null;
  extractionId: string | null;
  field: string | null;
  currentDismissalReason: ValidationDismissalReason | null;
  error: string | null;
  errorDetail: string | null;
  isSingleExtractionMode?: boolean; // Hide "Apply to all" when viewing single extraction
}

export const validationDismissalDialogAtom = atom<ValidationDismissalDialogState>({
  isOpen: false,
  dataPoolId: null,
  validationId: null,
  extractionId: null,
  field: null,
  currentDismissalReason: null,
  error: null,
  errorDetail: null,
});
